import * as style from './styles.css';

interface IContentProps {
  motivationTop?: React.JSX.Element;
  button?: React.JSX.Element;
  motivationBottom?: React.JSX.Element;
  advantages?: React.JSX.Element;
}

export const Content: React.FC<IContentProps> = ({ motivationTop, button, advantages, motivationBottom }) => {
  return (
    <div className={style['container']}>
      {motivationTop}
      {button}
      {advantages}
      {motivationBottom}
    </div>
  );
};
